import { useState, useEffect } from 'react';

/**
 * hook that wraps the getContentFromChildren helper and uses state to make
 * sure that current view is always up to date.
 */
function usePostloadedContent(children) {
  const [content, setContent] = useState(() => {
    return children instanceof Promise ? undefined : children;
  });

  // respond to changes to the content rendered inside the lightbox, and make
  // sure to wrap it in the desired size
  useEffect(() => {
    Promise.resolve(children).then(setContent);
  }, [children]);
  return content;
}

export { usePostloadedContent };
//# sourceMappingURL=hook.postloaded-content.js.map
